export default "* Læder eller stof\n* Cirkelformet skabelon i pap Ø ca. 25 cm\n* Tusch\n* Hultang\n* Saks\n* Lædersnøre eller snor af naturmaterialer\n";